import React from "react";
import moment from 'moment';
import MessageListItem from "./MessageListItem";

import MakeOrderDatePriceInfo from "./MakeOrderDatePriceInfo";
import LeftSide from "./LeftSide";
import ArbitrageModal from "./ArbitrageModal";
import EvaluateWork from "./EvaluateWork";
import ShareWork from "./Modals/ShareWork";
import BlacklistModal from "./Modals/blacklistModal";
import DownloadErrorMessage from "./Modals/downloadErrorMessage";
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import { connect } from "react-redux";
import {
    getExecutors,
    sendComplaint,
    uploadWork,
    uploadVideoWork,
    evaluateWork,
    acceptWork,
    downloadWork,
    cancelOrder,
    removeWorkPhoto,
    removeWorkVideo,
    getExecutorMessages,
    getExecutorPhotos,
    getExecutorVideos
} from '../../actions/orderActions';

import { getCurrentUserSuccess } from '../../actions/session';
import {getHeader, getDateTime, UTCToLocal} from '../../helper';
import axios from 'axios';
import PublishAllResults from "./Modals/PublishAllResults";

const arbitrageMessages = {
    empty: 'Опишите жалобу',
    sended: 'Ваша жалоба отправлена.',
}

class MakeOrderPay extends React.Component {

    state = {
        files: [],
        fileReaderResults: [],
        uploadFile: null,
        inputTypeFileValue: '',

        uploadState: {},

        evaluateWork: {
            type: 'default',
            show: false,
            punctuality_rate: 0,
            result_rate: 0,
            methodology_rate: 0,
            bid_id: null,
        },

        arbitrageAlert: {
            type: "default",
            show: false,
            text: "Опишите вашу жалобу подробно.",
            complaint: '',
            error: '',
            maxSymbols: 2000,
            bid: null,
        },

        publishResult: {
            type: "default",
            show: false,
        },
        
        shareModal: {
            type: "default",
            show: false,
            executor: {},
            social: '',
            setimages: [],
            setvideos: [],
            shareType: '',
            shareTitle: this.props.currentOrder.title,
            shareText: this.props.currentOrder.content,
            showButtons: false,
            price: 0,
            errorMsg: {},
            isReady: false,
        },

        blacklistModal: {
            type: "default",
            show: false,
            user: {},
            title: 'Добавление в черный список',
            text: "Вы уверены, что хотите добавить пользователя {user} в черный список?"
        },
         
        downloadError: {
            type: "danger",
            show: false,
            title: "",
            text: ""
        }
    }

    componentWillMount() {
        const { dispatch, currentOrder } = this.props;
        dispatch(getExecutors(currentOrder.id));
    }

    uploadWorks(e, bid_id, position_id, isVideo) {
        e.preventDefault();
        if(!this.props.session.isLoggedIn) return false;

        const settings = this.props.data["settings"];
        var files = e.target.files;
        let file;
        const prepareFile = e.target.files[0];
        if(!prepareFile) return false;
        let type = prepareFile.type.split("\/")[0];

        if(settings && settings.allow_upload_only_mp4 && isVideo && prepareFile.type !== 'video/mp4') {
            Alert.error('Ошибка. Загружаемое видео должно быть в формате mp4', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return false;
        }

        if((!isVideo && type === 'video') || (isVideo && type === 'image') || !(type === 'image' || type === 'video')) {
            return false;
        }

        this.setState({
            // files: [
            //     ...files,
            //     ...this.state.files,
            // ]
            files: files[0],

            uploadState: {
                ...this.state.uploadState,
                [position_id]: true
            }
        });

        for (var i = 0; i < files.length; i++) {
            file = files[i];
            var reader = new FileReader();

            reader.onload = (e) => {
                this.setState({
                    uploadFile: e.target.result,
                    inputTypeFileValue: '',
                    fileReaderResults: [
                        e.target.result,
                        ...this.state.fileReaderResults,
                    ]
                }, () => {
                    this.uploadToServer(
                        bid_id,
                        position_id,
                        isVideo
                    )
                })
            }
            reader.readAsDataURL(file);
        }
    }

    uploadToServer(bid_id, position_id, isVideo, callback) {
        let formData = new FormData();

        if(isVideo) formData.append('video', this.state.files)
        else formData.append('image', this.state.files)
        formData.append('bid_id', bid_id);
        formData.append('position_id', position_id);

        if(isVideo) {
            this.props.dispatch(
                uploadVideoWork(
                    formData,
                    bid_id,
                    () => this.uploadWorkSuccess(position_id),
                    () => {
                        this.uploadWorkSuccess(position_id);
                        this.uploadWorkError()
                    }
                ))
        }
        else {
            this.props.dispatch(
                uploadWork(
                    formData,
                    bid_id,
                    () => this.uploadWorkSuccess(position_id),
                    () => {
                        this.uploadWorkSuccess(position_id);
                        this.uploadWorkError()
                    }
                ))
        }
    }

    uploadWorkSuccess(position_id) {
        this.setState({
            uploadState: {
                ...this.state.uploadState,
                [position_id]: false,
            }
        })
    }

    uploadWorkError() {
        Alert.error('Ошибка. Работа не загрузилось.', {
            position: 'bottom-left',
            effect: 'stackslide',
            timeout: 5000
        });
    }

    deleteImageInServer(item, bid_id) {
        if(!this.props.session.isLoggedIn) return false;
        this.props.dispatch(removeWorkPhoto(item, bid_id));
    }

    deleteVideoInServer(item, bid_id) {
        if(!this.props.session.isLoggedIn) return false;
        this.props.dispatch(removeWorkVideo(item, bid_id));
    }

    evaluateWorkOpen(bid_id) {
        if(!this.props.session.isLoggedIn) return false;
        this.setState({
            evaluateWork: {
                ...this.state.evaluateWork,
                show: true,
                bid_id
            }
        })
    }

    evaluateWorkConfirm() {
        const {bid_id, punctuality_rate, result_rate, methodology_rate} = this.state.evaluateWork;

        let formData = new FormData();
        formData.append('bid_id', bid_id);
        formData.append('punctuality_rate', punctuality_rate)
        formData.append('result_rate', result_rate);
        formData.append('methodology_rate', methodology_rate);

        this.props.dispatch(
            evaluateWork(
                formData,
                bid_id,
                () => this.setState({evaluateWork:{type:'success'}})
            )
        )
    }

    evaluateWorkClose() {
        this.setState({
            evaluateWork: {
                type: 'default',
                show: false,
                bid_id: null,
                punctuality_rate: 0,
                result_rate: 0,
                methodology_rate: 0,
            }
        })
    }

    onChangeRate(value, field) {
        this.setState({
            evaluateWork: {
                ...this.state.evaluateWork,
                [field]: value
            }
        })
    }

    handleAcceptWork(bid_id) {
        if(!bid_id) return false;
        if(!this.props.session.isLoggedIn) return false;
        const {dispatch} = this.props;
        
        dispatch(acceptWork(
            bid_id,
            () => {
                dispatch(getExecutorMessages(bid_id));
                dispatch(getExecutorPhotos(bid_id));
                dispatch(getExecutorVideos(bid_id));
            }
        ));
    }

    confirmArbitrage() {
        const {complaint, bid} = this.state.arbitrageAlert;

        if(complaint.trim().length === 0){
            this.setState({
                arbitrageAlert: {
                    ...this.state.arbitrageAlert,
                    error: arbitrageMessages.empty,
                }
            })
            return;
        }

        let params = {
            content: complaint,
            bid_id: bid.id
        };

        this.props.dispatch(sendComplaint(
            params,
            () => {
                this.setState({
                    arbitrageAlert: {
                        ...this.state.arbitrageAlert,
                        type: 'success'
                    }
                })
            }
        ));
    }

    handleOpenArbitrage(bid) {
        if(!this.props.session.isLoggedIn) return false;
        this.setState({
            arbitrageAlert:{...this.state.arbitrageAlert,show:true, bid}
        });
    }

    closeArbitrage() {
        this.setState({
            arbitrageAlert:{
                ...this.state.arbitrageAlert,
                show:false,
                complaint:'',
                type:'default',
                bid:null,
                error:''
            }
        })
    }

    handleArbitrageText(e) {
        const {value} = e.target;
        const length = value.length;
        let error = '';

        error = (length === 0) ? arbitrageMessages.empty : ''

        if(length > this.state.arbitrageAlert.maxSymbols) return false;

        this.setState({
            arbitrageAlert:{
                ...this.state.arbitrageAlert,
                complaint: value,
                error
            }
        })
    }

    openShareModal(executor) {
        if(!this.props.session.isLoggedIn) return false;
        this.setState({
            shareModal:{
                ...this.state.shareModal,
                show:true,
                executor,
            }
        });
    }

    onClickPhoto(photo, type) {
        let setName = `set${type}s`;
        let newPhotos;
        
        const isSelected = this.state.shareModal[setName].filter(selphoto => selphoto.id === photo.id).length;
        
        if(isSelected) {
            newPhotos = this.state.shareModal[setName].filter(selphoto => selphoto.id !== photo.id)
        } else {
            newPhotos = [
                ...this.state.shareModal[setName],
                {...photo, type}
            ]
        }

        this.setState({
            shareModal: {
                ...this.state.shareModal,
                [setName]: newPhotos
            }
        })
    }

    onHandleChange(e) {
        this.setState({
            shareModal: {
                ...this.state.shareModal,
                [e.target.name]: e.target.value
            }
        })
    }

    confirmShare() {
        const bid_id = this.state.shareModal.executor.id,
            {
                shareTitle,
                shareText,
                setimages,
                setvideos,
                shareType,
                price,
            } = this.state.shareModal;
        
        const photoIDs = setimages.map(photo => photo.id);
        const videoIDs = setvideos.map(photo => photo.id);
        let photos = photoIDs.length ? true : false;
        let videos = videoIDs.length ? true : false;
        let isReady = true;

        let params = {
            title: shareTitle,
            description: shareText,
            price,
            order_id: this.props.currentOrder.id,
        };

        if(photos) params.photos_str = photoIDs.join(',')
        if(videos) params.videos_str = videoIDs.join(',')
        
        if(!photos && !videos) {
            isReady = false;
            this.setState({
                shareModal: {
                    ...this.state.shareModal,
                    errorMsg: {
                        ...this.state.shareModal,
                        results: 'Фото/Видео не выбрано для публикации'
                    }
                }
            })
        }
        else{
            isReady = true;
            this.setState({
                shareModal: {
                    ...this.state.shareModal,
                    errorMsg: {
                        ...this.state.shareModal,
                        results: null
                    }
                }
            })
        }

        if(!isReady) {
          //  this.setState({shareModal:{...this.state.shareModal, isReady}})
            return false;
        }

        axios.post(
            `${window.siteUrl}/api/v1/photo_video_pack/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(response => {            
            this.setState({
                shareModal: {
                    ...this.state.shareModal,
                    type: 'success'
                }
            });

            setTimeout(() => {
                this.props.history.push(`/buy/single/${response.data.id}`);
            }, 1300)
        })
        .catch(error => {
            this.setState({
                shareModal: {
                    ...this.state.shareModal,
                    type: 'error',
                    errorMsg: error.data
                }
            })
        })
    }

    closeShareModal() {
        this.setState({
            shareModal:{
                ...this.state.shareModal,
                show:false,
                type:'default',
                executor:{},
            }
        })
    }

    openPublishResultModal(e) {
        e.preventDefault();

        this.setState({
            publishResult:{
                ...this.state.publishResult,
                show: true,
                type: 'default',
            }
        })
    }

    closePublishResult() {
        this.setState({
            publishResult: {
                ...this.state.publishResult,
                show: false,
                type: 'default',
            }
        })
    }

    confirmPublishResult() {
        const {currentOrder} = this.props;

        axios.post(
            `${window.siteUrl}/api/v1/photo_video_pack/publish_all/`,
            {
                order_id: currentOrder.id
            },
            {
                headers: getHeader()
            }
        )
        .then(response => {            
            this.setState({
                publishResult: {
                    ...this.state.publishResult,
                    type: 'success'
                }
            });

            setTimeout(() => {
                this.props.history.push(`/buy/?order_by=-created_at&order_id=${currentOrder.id}`);
                // this.closePublishResult();
            }, 1300)
        })
        .catch(error => {
            this.setState({
                publishResult: {
                    ...this.state.publishResult,
                    type: 'error',
                }
            })
        })
    }

    handleBlacklistClick(user) {
        if(!this.props.session.isLoggedIn) return false;
        this.setState({
            blacklistModal: {
                ...this.state.blacklistModal,
                show: true,
                user
            }
        })
    }

    confirmBlacklist() {
        const user = this.state.blacklistModal.user;

        axios.post(
            `${window.siteUrl}/api/v1/user/${user.id}/add_to_blacklist/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(response => {
            const currentUser = this.props.session.currentUser;
            const newBlackList = currentUser.blacklist_users;
            newBlackList.push(user);
            const payload = { blacklist_users: newBlackList };
            this.props.dispatch(getCurrentUserSuccess(payload));
            this.setState({
                blacklistModal: {
                    ...this.state.blacklistModal,
                    type: "success",
                    text: "{user} добавлен в черный список"
                }
            })
        })
        .catch(error => {
            console.error(error.data);
        })
    }

    closeBlacklist() {
        this.setState({
            blacklistModal: {
                ...this.state.blacklistModal,
                show: false,
                type: 'default'
            }
        })
    }

    downloadWork(executor) {
        const {currentOrder} = this.props;
        if(!this.props.session.isLoggedIn) return false;

        const { dispatch } = this.props;
        dispatch(downloadWork(executor.id, (params) => {
            if(params.link) {  
                const downloader = document.createElement("a");
                downloader.setAttribute('href', window.siteUrl + params.link);
                downloader.setAttribute('download', '');
                downloader.click();
                downloader.remove();
                
                if(!currentOrder.is_failed && executor.status === 4 ) {
                    this.evaluateWorkOpen(executor.id);
                }

            } else {
                this.setState({
                    downloadError: {
                        ...this.state.downloadError,
                        show: true,
                        title: params.error.status,
                        text: params.error.errorMsg,
                    }
                })
            }
        }));
    }

    render() {
        const {currentOrder, orderList, session, repeatOrder, currentCamera, cancelOrder, editOrder, data} = this.props;
        const {currentUser, isLoggedIn} = session;
        const executorById = orderList.orderById.executorById;
        const isFetching = orderList.isFetching;
        const isCustomer = currentOrder.user_id === currentUser.id;
        const dataSettings = data['settings'];

        let startDate = getDateTime(new Date(currentOrder.order_date_at), currentOrder.order_time_at);
        let endDate = getDateTime(new Date(currentOrder.order_date_end_at), currentOrder.order_time_end_at);
        let startDateUTC = UTCToLocal(startDate.dateTime);
        let endDateUTC = UTCToLocal(endDate.dateTime);

        let now = moment();

        // если ниже нуля (-number) время не наступило
        // если больше нуля время прошло
        let startShooting = (moment().diff(startDateUTC, 'minutes') < 0);
        let endShootingDatetime = moment(endDateUTC).format('MM/DD/YYYY HH:mm');
        let endShooting = (moment().diff(endDateUTC, 'minutes') > 0);

        let dateForSettings = '';
        let dateForSettingsBoolean = false;
        if(!currentOrder.is_test && dataSettings.hours_for_auto_accept) {
            dateForSettings = moment(endShootingDatetime).add(dataSettings.hours_for_auto_accept, 'hours').format("MM/DD/YYYY HH:mm");
            dateForSettingsBoolean = dateForSettings < now.format('MM/DD/YYYY HH:mm')
        }

        let shootingTitle = null;

        if(startShooting) shootingTitle = `Время исполнения заказа начнется ${moment(startDateUTC).format('DD.MM.YYYY')} в ${moment(startDateUTC).format('HH')} часов ${moment(startDateUTC).format('mm')} минут`;
        if(endShooting) shootingTitle = "Время исполнения заказа закончилось";
        let executors = [];

        if(isCustomer) {
            // executors = executorById.data.results.filter(item => item.status !== 7 && item.status !== 6);
            executors = executorById.data.results.filter(item => item.status !== 7);
        }
        else{
            executors = Object.assign([], executorById.data.results);
        }

        let executorsWithoutAutoCancel = executorById.data.results.filter(item => item.status !== 7 && item.status !== 6);

        return (
            <div>
                <ArbitrageModal
                    inputProps={this.state.arbitrageAlert}
                    onConfirm={() => this.confirmArbitrage()}
                    onCancel={() =>  this.closeArbitrage()}
                    onChangeText={(e) => this.handleArbitrageText(e)}
                    arbitrageMessages={arbitrageMessages}
                    />

                <BlacklistModal
                    inputProps={this.state.blacklistModal}
                    onConfirm={() => this.confirmBlacklist()}
                    onCancel={() =>  this.closeBlacklist()}
                    />

                <EvaluateWork
                    inputProps={this.state.evaluateWork}
                    onConfirm={() => this.evaluateWorkConfirm()}
                    onCancel={() =>  this.evaluateWorkClose()}
                    onChangeRate={(value, field) => this.onChangeRate(value, field)}
                    />

                <ShareWork
                    session={session}
                    inputProps={this.state.shareModal}
                    onConfirm={() => this.confirmShare()}
                    onCancel={() =>  this.closeShareModal()}
                    onChangeRate={(value, field) => this.onChangeRate(value, field)}
                    onHandleChange={(e) => this.onHandleChange(e)}
                    onClickPhoto={(photo, type) => this.onClickPhoto(photo, type)}
                    />

                <PublishAllResults
                    inputProps={this.state.publishResult}
                    onConfirm={() => this.confirmPublishResult()}
                    onCancel={() =>  this.closePublishResult()}
                    />

                <DownloadErrorMessage
                    inputProps={this.state.downloadError}
                    onConfirm={() => this.setState({ downloadError: { ...this.state.downloadError, show: false } })}
                    />

                <Alert stack={{limit: 1}} />

                <div className="vertical-scrolling page fourthSection sectionMakeOrder" id="sectionMakeOrder" data-main-nav-id="makeOrdersNavLink">
                    <div className="container content">

                        <LeftSide
                            inputProps={{
                                orderId: currentOrder.id,
                                status: currentOrder.status,
                                is_failed: currentOrder.is_failed,
                                is_auction: currentOrder.is_auction,
                                fail_reason_str: currentOrder.fail_reason_str,
                                paramId: this.props.params.id,
                            }}
                            />

                        <div className="right-content native-scroll right-content-bottom right-content-width">
                            <div className="screen-outer-block-wrap native-scroll menu-content">

                                <div className="menu-content-make-order-pay menu-content-item tab-parent screen-bottom-block">
                                    <div className="rounded-white-block">

                                        <div className="white-block-top header-tab">
                                            <h3>{currentOrder.title}</h3>
                                        </div>

                                        <div className="unlimited-block">

                                            <MakeOrderDatePriceInfo
                                                repeatOrder={repeatOrder}
                                                cancelOrder={cancelOrder}
                                                editOrder={editOrder}
                                                currentUserID={currentUser.id}
                                                {...currentOrder}
                                                isLoggedIn={isLoggedIn}
                                                currentOrder={currentOrder}
                                                isFailed={orderList.data.is_failed}
                                                currentCamera={currentCamera}
                                                executors={executorsWithoutAutoCancel}
                                            />

                                            
                                            <div>
                                                <div className="semiheader">
                                                    <h3>{currentOrder.status === 1 ? 'Претенденты' : 'Выполнение и результаты'}</h3>
                                                </div>

                                                {
                                                    currentOrder.status === 1 && (!isLoggedIn || isCustomer)
                                                    ?
                                                    <div className="applicants" style={{padding:'20px'}}>
                                                        <p>Количество претендентов: {executorsWithoutAutoCancel.length}</p>
                                                    </div>
                                                    : null
                                                }

                                                {
                                                    currentOrder.status === 1 && currentOrder.is_my_bid
                                                    ?
                                                    <h3 style={{padding:'20px', color: '#64ab15', fontSize:'15px'}}>Вы откликнулись на заказ</h3>
                                                    : null
                                                }
                                                
                                                {
                                                    !currentOrder.is_test && (currentOrder.status === 9 || (currentOrder.status === 3 || currentOrder.status === 4) && shootingTitle) ?
                                                    <div className="alert-note-error-clock">
                                                        {shootingTitle}
                                                    </div>
                                                    : null
                                                }

                                                {
                                                    !currentOrder.allow_upload_results_from_web && (currentOrder.status >= 1 && currentOrder.status <= 3) ?
                                                    <div style={{marginBottom:'30px',marginTop:'-10px',background:'rgb(231, 76, 60)',color:'rgb(255, 255, 255)',padding:'10px'}}>
                                                        Загрузка работ возможна только с мобильного устройства
                                                    </div>
                                                    : null
                                                }

                                                {
                                                    currentOrder.status === 1
                                                    ? null
                                                    :
                                                    <ul className="executor-list-with-messages">
                                                        {
                                                            executors.map((item, index) => {
                                                                // if(item.status === 7 && isCustomer){
                                                                //     return
                                                                // }
                                                                if(isLoggedIn && item.status === 7 && !isCustomer) {
                                                                    return  <h3 key={index} style={{padding:'20px', color: 'red', fontSize:'15px'}}>
                                                                                Ваш отклик был отклонен автоматически
                                                                            </h3>
                                                                }

                                                                return (<MessageListItem
                                                                            key={index}
                                                                            index={index+1}
                                                                            executor={item}
                                                                            choiceComponent={"Result"}
                                                                            currentOrder={currentOrder}
                                                                            openArbitragePopup={(bid) => this.handleOpenArbitrage(bid)}
                                                                            handleAcceptWork={(bid) => this.handleAcceptWork(bid)}
                                                                            handleBlacklistClick={(user) => this.handleBlacklistClick(user)}
                                                                            uploadWorks={(e, bid, position_id, type) => this.uploadWorks(e, bid, position_id, type)}
                                                                            uploadState={this.state.uploadState}
                                                                            deleteImageInServer={(item, bid) => this.deleteImageInServer(item, bid)}
                                                                            deleteVideoInServer={(item, bid) => this.deleteVideoInServer(item, bid)}
                                                                            inputTypeFileValue={this.state.inputTypeFileValue}
                                                                            files={this.state.files}
                                                                            fileReaderResults={this.state.fileReaderResults}
                                                                            evaluateWork={(bid) => this.evaluateWorkOpen(bid)}
                                                                            openShareModal={(executor) => this.openShareModal(executor)}
                                                                            // openPublishResultModal={this.openPublishResultModal.bind(this)}
                                                                            downloadWork={() => this.downloadWork(item)}
                                                                            isFetching={isFetching}
                                                                            endShootingDatetime={endShootingDatetime}
                                                                            dateForSettingsBoolean={dateForSettingsBoolean}
                                                                            />);
                                                            })
                                                        }
                                                    </ul>
                                                }

                                                {
                                                    isCustomer && !currentOrder.is_failed && (currentOrder.status === 5 || currentOrder.status === 6) ?
                                                    <div style={{marginBottom: '12px', textAlign: 'center', paddingBottom: '30px'}}>
                                                        <a href="#" className="" onClick={this.openPublishResultModal.bind(this)}>Опубликовать все</a>
                                                    </div>
                                                    : null
                                                }
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(MakeOrderPay);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/MakeOrderPayTest.js